<template>
  <div id="examroom">
    <!-- {{PlugJson}} -->
  </div>
</template>

<script>
export default {
  name: "examroom"
};
</script>

<style scoped>
</style>